export default "__VITE_ASSET__db3b26f0__"